<script>
export default {
  name: 'App',
  data() {
    return {
      maxWidth: 736,
      isMobile: '',
      isEmbed: false
    }
  },
  created() {
    let _this = this;
    this.isMobile = window.matchMedia('(max-width:' + this.maxWidth + 'px)').matches;
    window.onresize = function (e) {
      _this.isMobile = e.target.matchMedia('(max-width:' + _this.maxWidth + 'px)').matches;
    }
  },
  mounted() {
    //const url = new URL(document.location.hash);
    //this.isEmbed = url.hash.match(/embed=true/)
  }
}
</script>

<template>
  <div class="main" :class="{embed:isEmbed}">
    <transition name="fade" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>